export function sortObjectByText(array, key) {
  const result = array.sort((a, b) => {
    const x = a[key].toLowerCase();
    const y = b[key].toLowerCase();

    if (x === y) {
      return 0;
    }

    return x > y ? 1 : -1;
  });
  return result;
}

export function sortObjectByNumber(array, key) {
  return array.sort((a, b) => a[key] - b[key]);
}

export default { sortObjectByNumber, sortObjectByText };
